import { useRedirectLink } from "../../utils";
import { useSDMRouterContext } from "@ldp/sdm-contexts";
import { useSettingsContext } from "@ldp/common-contexts";
import React, { FC } from "react";
import { SearchBar } from "@ldp-web/component-library/ui/atoms/form/search-bar";
import { useUpdateQueryParam } from "../../hooks";
import { SDMLanguageType } from "@ldp/common-types";

/** Search bar props */
export interface ISearchBarComponentProps {
  children?: React.ReactNode;
  url: string;
}

/** Renders Search bar component */
export const SearchBarComponent: FC<ISearchBarComponentProps> = ({}) => {
  const router = useSDMRouterContext();
  const redirectToPage = useRedirectLink(router);
  const settings = useSettingsContext();
  const locale = settings.locale as SDMLanguageType;
  const updateQueryParam = useUpdateQueryParam();
  const handleSearch = (val: string | number) => {
    const param = {
      text: val.toString(),
      lang: locale,
    };
    const updatedUrl = updateQueryParam(param);
    redirectToPage(updatedUrl);
  };
  return (
    <>
      <SearchBar
        name="search"
        placeholderText="Search"
        isElevated={false}
        onValueChange={handleSearch}
      />
    </>
  );
};

export default SearchBarComponent;
